const key = '__w3swap_referrer'

export const getReferrerFromLocal = () => {
  const local = localStorage.getItem(key)
  return local ? local : '0x22fc5edCb2D39998479163812e2EaDC4D55D9965'
}

export const setReferrerToLocal = (val) => {
  localStorage.setItem(key, val)
}